'use client';
import { formatData } from '@hyphengroup/cms-components/utils/helpers';
import { tr } from '@hyphengroup/cms-components/utils/translations/tr';
import { UseApprovalOddsReturn } from '$/(cms)/_modules/approvalOdds/useApprovalOdds';
import { TRANSLATIONS } from '$/components/cms/translations';
import RefreshIcon from '$/components/icons/RefreshIcon';
import { useClientContext } from '$/modules/context/client';
import { getClientTranslations } from '$/modules/i18n/client.index';

type ApprovalOddsFooterProps = {
  approvalOddsData: UseApprovalOddsReturn['data'] | null;
  onRefresh?: () => void;
};

export const ApprovalOddsFooter = ({
  approvalOddsData,
  onRefresh,
}: ApprovalOddsFooterProps) => {
  const context = useClientContext();
  const staticText = getClientTranslations(TRANSLATIONS, context);

  const isVisible =
    approvalOddsData?.userState &&
    ['expired', 'fresh'].includes(approvalOddsData?.userState) &&
    !!approvalOddsData.lastUpdated &&
    Object.keys(approvalOddsData.odds).length > 0;

  if (!isVisible) {
    return null;
  }

  const dateFormat = tr('approval_odds_date_format', staticText);
  const formattedDate = formatData(
    approvalOddsData.lastUpdated!,
    dateFormat,
    context.lang,
  );

  const isFresh = approvalOddsData?.userState === 'fresh';

  const text = tr('approval_odds_last_updated', staticText, {
    date: formattedDate,
  });

  return (
    // eslint-disable-next-line tailwindcss/no-custom-classname, tailwindcss/classnames-order
    <div className="flex flex-row items-center justify-between gap-2 rounded-b-radius/table bg-colors/neutral-gray-200 px-1.5 py-3 md:px-4 md:py-2">
      {/* eslint-disable-next-line tailwindcss/no-custom-classname */}
      <div className="font-font-weight/table-cell-normal text-text/secondary-lighter text-font-size/table-cell leading-line-height/table-cell">
        {text}
      </div>
      {!isFresh && (
        <button
          onClick={() => {
            onRefresh?.();
          }}
          type="button"
          // eslint-disable-next-line tailwindcss/classnames-order
          className="flex flex-row items-center gap-1 text-text/primary mhg-alpha-typography-bullet-2"
        >
          <RefreshIcon width="18" height="18" />
          {tr('approval_odds_refresh', staticText)}
        </button>
      )}
    </div>
  );
};
